import type { Splide, Options } from '@splidejs/splide'

const getWindow = (index, total) => {
  const max = 5
  let start = Math.max(index - 3, 0)
  let end = Math.min(index + 4, total)
  if (end - start < max) {
    start = Math.max(end - max, 0)
    if (start === 0) {
      end = max
    }
  }
  return [ start, end ]
}

export const attachPagination = (instance: Splide, options: Options) => {
  instance.on('pagination:mounted', ({ list }) => {
    const btn = instance.root.querySelector('.splide__toggle')
    if (options.autoplay && btn) {
      const li = document.createElement('li')
      li.classList.add('splide__toggle-container')
      li.setAttribute('role', 'presentation')
      li.append(btn)
      list.prepend(li)
      btn.classList.remove('hidden')
      instance.on('drag', () => {
        const { Autoplay } = instance.Components
        Autoplay.pause()
      })
    }
  })

  if (options.limitDots !== false) {
    instance.on('pagination:updated', ({ items }) => {
      if (items.length < 7) {
        return
      }
      const [ start, end ] = getWindow(instance.index, items.length)
      // reset
      items.forEach(i => {
        const { classList } = i.li
        classList.remove('border', 'scale-0', 'scale-50', 'scale-75', 'scale-100')
        classList.add('scale-0')
      })
      // scale
      items.slice(start, end).forEach((i, index) => {
        index = instance.index < 3 ? index + 2 : index
        const { classList } = i.li
        const css = [ 0, 6 ].includes(index) ? 'scale-50' :
          [ 1, 5 ].includes(index) ? 'scale-75' :
            [ 2, 3, 4 ].includes(index) ? 'scale-100' :
              'scale-0'
        classList.remove('scale-0')
        classList.add(css)
      })
    })
  }
}
